var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"view-event"},[_c('p',[_vm._v("Enable Break Konnect Payment System to accept online payments for event tickets.")]),_c('p',[_c('span',{staticClass:"view-event__bold-title"},[_vm._v("Current status:")]),_vm._v(" "+_vm._s(_vm.eventData.paymentSystem?.isEnabled ? 'Enabled' : 'Disabled')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }